import "../../main.js";
/*jshint esversion: 6 */
import Vue from 'vue';

import App from "./App.vue";
import routes from "./routes.js";
import store from "./store.js";

import VueRouter from 'vue-router';
const router = new VueRouter({routes});

//Fonter.load(["Open Sans"]);

Vue.http.options.root = '//'+location.host+'/api/v1';
Vue.http.options.credentials = true;
Vue.importComponents(["i-multi-select","i-list-editor","i-date-picker","i-toggle","i-wysiwyg-service","i-list","modal-control-buttons","i-form","modal","i-button-toggle","i-array-editor","multi-input","i-lang-input","i-uploader","i-wysiwyg"])
//http://localhost:8001/gearbox-cms/api/v1/

new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store
});




